import * as React from 'react'
import Pagination from '@material-ui/lab/Pagination'
import cn from 'classnames'
import * as styles from './styles.module.css'

const _Pagination = ({
  className,
  total,
  limit,
  page,
  onChange
}) => {
  const count = Math.ceil(total / limit)
  return (
  <Pagination
    className={cn('mui-pagination', styles.pagination, className)}
    count={count}
    page={page}
    onChange={onChange} />
)}
export default _Pagination